import React from "react";

import { Trans } from "app/utils";
import subtitlesEmptyState from "images/subtitles-empty-state.png";

const SubtitlesLoader: React.FC<{}> = () => (
  <div className="Subtitles-Loading">
    <p>
      <Trans>
        Your subtitles are being generated and will show up
        here once they&apos;re ready...
      </Trans>
    </p>
    <img
      className="Subtitles-Loading__Image"
      src={subtitlesEmptyState}
      alt="Empty Subtitles"
    />
  </div>
);

export default SubtitlesLoader;
